const ROUTES = {
  HOME: '/',
  
  // Sentinel routes
  SENTINEL: '/sentinel',
  SENTINEL_FEATURES: '/sentinel/features',
  SENTINEL_ABOUT: '/sentinel/about',
  
  // Other pages
  LOGIN: '/login',
  CONTACTS: '/contacts',
  FEATURE_REQUEST: '/feature-request',
  
  NOT_FOUND: '/404'
};

export default ROUTES;
